import React, { useState, useEffect } from 'react';
import { MapContainer, TileLayer, Marker, Popup, useMapEvents } from 'react-leaflet';
import 'leaflet/dist/leaflet.css';
import L from 'leaflet';
import { Box } from '@mui/material';
import icon from 'leaflet/dist/images/marker-icon.png';
import iconShadow from 'leaflet/dist/images/marker-shadow.png';

const DefaultIcon = L.icon({
  iconUrl: icon,
  shadowUrl: iconShadow,
  iconSize: [25, 41],
  iconAnchor: [12, 41],
});

L.Marker.prototype.options.icon = DefaultIcon;

interface SimpleMapProps {
  center?: [number, number];
  zoom?: number;
  height?: string | number;
  width?: string | number;
  onPinLatLong?: (lat: number, long: number) => void;
}

const MapClickHandler: React.FC<{
  onLocationClick: (lat: number, lng: number) => void;
}> = ({ onLocationClick }) => {
  useMapEvents({
    click(e) {
      onLocationClick(e.latlng.lat, e.latlng.lng);
    },
  });

  return null;
};

const SimpleMap: React.FC<SimpleMapProps> = ({
  center = [-15.7801, -47.9292],
  zoom = 4,
  height = 400,
  width = '100%',
  onPinLatLong,
}) => {
  const [markerPosition, setMarkerPosition] = useState<[number, number]>(center);

  useEffect(() => {
    setMarkerPosition(center);
  }, []);

  const handleMapClick = (lat: number, lng: number) => {
    setMarkerPosition([lat, lng]);
    onPinLatLong?.(lat, lng);
  };

  return (
    <Box
      sx={{
        height: typeof height === 'number' ? `${height}px` : height,
        width: typeof width === 'number' ? `${width}px` : width,
        borderRadius: 1,
        overflow: 'hidden',
        border: '1px solid #e0e0e0',
      }}
    >
      <MapContainer
        center={center}
        zoom={zoom}
        style={{ height: '100%', width: '100%' }}
        scrollWheelZoom={true}
      >
        <TileLayer
          attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
        />

        <MapClickHandler onLocationClick={handleMapClick} />

        <Marker
          position={markerPosition}
          icon={DefaultIcon}
        >
          <Popup>
            Lat: {markerPosition[0].toFixed(6)}, Lng: {markerPosition[1].toFixed(6)}
          </Popup>
        </Marker>
      </MapContainer>
    </Box>
  );
};

export default SimpleMap;